import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetPublicChallengeTranslationResponse } from './get-public-challenge-translation-response';
import { getPublicChallengeTranslationResponseSchema } from './get-public-challenge-translation-response';

export async function getPublicChallengeTranslationApi(
  challengeId: number,
  lang: string,
): Promise<IValidatedResponse<IGetPublicChallengeTranslationResponse>> {
  return getRequest<IGetPublicChallengeTranslationResponse>({
    path: `/challenges/${challengeId}/translation?lang=${encodeURIComponent(lang)}`,
    schema: getPublicChallengeTranslationResponseSchema,
  });
}
